import { AlertCircle } from "lucide-react";

import { HealthlinkXsltFrame } from "features/healthlink/components/HealthlinkXsltFrame/HealthlinkXsltFrame";

import { CDM_MESSAGE_XSL } from "../../utils/cdmMessageXsl";
import styles from "./CdmMessagePreview.module.css";

/**
 * Renders a CDM/OCF/PP HL7 ORU_R01 clinical message as a styled, printable view
 * using our own XSL stylesheet (no Healthlink-hosted stylesheet exists for the
 * CDM message family). When there is no message XML yet, shows a neutral notice
 * (icon + title + description, same layout as PCRSStatusBar) so it is clear the
 * preview is unavailable rather than silently blank.
 */
export const CdmMessagePreview = ({ xml }) => {
  if (!xml) {
    return (
      <section className={styles.wrapper}>
        <div className={styles.notice} role="status">
          <AlertCircle size={20} className={styles.icon} aria-hidden />
          <div className={styles.text}>
            <p className={styles.title}>No message preview</p>
            <p className={styles.message}>
              There is no message available to preview for this review.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.wrapper}>
      <HealthlinkXsltFrame xml={xml} xsl={CDM_MESSAGE_XSL} />
    </section>
  );
};
